import React from 'react'
import {Box, Flex, Container} from '../../../vanilla'
import {CmsImage} from '../cms-image'
import {CTAButton} from '../../../vanilla/components/CTAButton'
import {SlotComponent} from '../../../types/ui'
import {thinBannerCtaPosition, thinBannerImage} from './styles.css'
import {ThinBanner as ThinBannerType} from '../../../types/cms'
import {useSelectPromotionTracking} from '../../../analytics/promotion-tracking'
import {createPromoForSelectPromotion} from '../../../analytics/utils'

export const ThinBanner: SlotComponent<ThinBannerType> = ({content, slotGroupName, slotIndex}) => {
  const images = content?.image?.image?.images
  const cta = content?.cta
  const sendSelectPromotion = useSelectPromotionTracking()

  // Create object for select_promotion event
  const selectPromoInfo = {
    content,
    slotGroupName,
    slotPosition: slotIndex
  }
  const promotion = createPromoForSelectPromotion(selectPromoInfo)

  if (!images) {
    return null
  }

  return (
    <Box width="full" position="relative" overflow="hidden">
      <Container paddingX="0px">
        <Box position="relative">
          <Flex align="stretch" flexDirection={['column', 'row']}>
            <CmsImage
              queryParams={[
                {w: 1752, fmt: 'auto', qlt: 'default'},
                {w: 3504, fmt: 'auto', qlt: 'default'}
              ]}
              className={thinBannerImage}
              images={images}
              width="full"
              height="auto"
              imageLink={content?.image?.imageLink}
              onClick={() => {
                sendSelectPromotion(promotion)
              }}
            />
          </Flex>
          {cta ? (
            <Box position="absolute" className={thinBannerCtaPosition[cta.ctaPosition ?? 'Right']}>
              {cta?.ctaText && (
                <CTAButton
                  cta={cta}
                  onClickCapture={() => {
                    sendSelectPromotion(promotion)
                  }}
                />
              )}
            </Box>
          ) : null}
        </Box>
      </Container>
    </Box>
  )
}
